import { render } from "./validation-detail.vue?vue&type=template&id=d1d2b9c8"
import script from "./validation-detail.vue?vue&type=script&lang=js"
export * from "./validation-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__